import KT01BaseLayout from 'general/components/BaseLayout/KT01BaseLayout';
import { Route, Routes } from 'react-router-dom';
import ChargeModelListScreen from '../ChargeModel/screens/ChargeModelListScreen';
import ChargeBrandListScreen from './screens/ChargeBrandListScreen';

ChargeBrand.propTypes = {};

function ChargeBrand(props) {
  return (
    <KT01BaseLayout isFullScreen={true}>
      <div className="container-fluid px-0">
        <Routes>
          <Route path="" element={<ChargeBrandListScreen />} />
          <Route path=":chargeBrandId" element={<ChargeModelListScreen />} />
          <Route path="*" element={<>Đường dẫn không hợp lệ</>} />
        </Routes>
      </div>
    </KT01BaseLayout>
  );
}

export default ChargeBrand;
